import { render, staticRenderFns } from "./Segment.vue?vue&type=template&id=3994fdba&scoped=true"
import script from "./Segment.vue?vue&type=script&lang=js"
export * from "./Segment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3994fdba",
  null
  
)

export default component.exports